import { ref, reactive } from 'vue'

// Öneri listesi - filtrelenmiş ve sayfalanmış sonuçlar
export const suggestions = ref([])

// Tüm öneri listesi - filtreleme ve sayfalama için kullanılan kaynak veri
export const allSuggestions = ref([])

// Seçili öneri
export const selectedSuggestion = ref(null)

// Yükleniyor durumu
export const loading = ref(false)

// Hata durumu
export const error = ref(null)

// Sayfalama verileri
export const pagination = reactive({
  total: 0,
  page: 1,
  limit: 10,
  pages: 0
})

// Filtreler
export const filters = reactive({
  contentType: '',
  contentCategory: '',
  contentId: '',
  priority: '',
  assetId: null, // Asset ID'yi filtrelere ekledik
  sort: 'createdAt',
  order: 'desc'
})
